<template lang="pug">

.sign-wrap
    .sign.shadow_center

        .sign__head
            .sign__step.sign__step_title(
                v-if="activeTab === 'recovery' || activeTab === 'recovery step 1'"
            ) {{ $t('views.login.title_recovery') }}

            .sign__step.sign__step_title(
                v-else-if="activeTab === 'successRegistration'"
            ) {{ $t('views.login.title_reg') }}

            template(v-else)
                .sign__step(
                    @click="activeTab = 'registration'",
                    :class="{sign__step_active: activeTab == 'registration'}",
                ) {{ $t('views.login.title_reg') }}
                .sign__step(
                    @click="activeTab = 'login'",
                    :class="{sign__step_active: activeTab == 'login'}",
                ) {{ $t('views.login.title') }}

        form.sign__data(
            v-if="activeTab === 'registration'"
            @submit.prevent="signUp()"
        )
            //- if error use on input :err="'koka ya to oshibka'",
            buzz-input(
                :placeholder="$t('views.login.email')",
                v-model="inputRegData",
                :type="'big'",
                :err="inputRegDataErrors"
                @input="inputRegDataErrors = ''"
            )
            .sign__input-wrap(:class="{'sign__input-wrap_err': !isAgree && wasSubmited}")
                .sign__input
                    buzz-checkbox(
                        :isError="isAgree",
                        @change="changeAgreement"
                    )
                .sign__input-text-wrap
                    span.sign__input-text {{ $t('views.login.accept') }}
                    a.sign__input-link(:href="user_agreement_page" target="_blank") {{ $t('views.login.accept_link') }}
            .sign__button
                buzz-button(:type="['wide']") {{ $t('views.login.btn_sign_up') }}

        form.sign__data(
            v-else-if="activeTab === 'login'"
            @submit.prevent="login(inputLoginData)"
        )
            //- if error use on input :err="'koka ya to oshibka'"
            buzz-input(
                :placeholder="$t('views.login.email')",
                :placeholder2="$t('views.login.password')",
                :type="'auth'",
                :err="login_errors"
                @auth-password="inputLoginPassword",
                @auth-email="inputLoginEmail",
                @not-remember="activeTab = 'recovery'",
            )
            .sign__button
                buzz-button(:type="['wide']") {{ $t('views.login.btn_sign_in') }}

        form.sign__data(
                v-else-if="activeTab === 'recovery'"
                @submit.prevent="passwordRecoveryRequest(inputRecoveryData)"
            )
            .sign__desc {{ $t('views.login.desc_reset') }}
            //- if error use on input :err="'koka ya to oshibka'"
            buzz-input(
                :placeholder="$t('views.login.email')",
                v-model="inputRecoveryData",
                :type="'big'",
                :err="inputPassReqErrors"
            )
            .sign__button
                buzz-button(:type="['wide']") {{ $t('views.login.btn_reset') }}
            .sign__txt
                span.link.sign__link(
                    @click="activeTab = 'login'",
                ) {{ $t('views.login.title') }}
                span.link.sign__link(
                    @click="activeTab = 'registration'",
                ) {{ $t('views.login.title_reg') }}

        .sign__data(v-else-if="activeTab === 'successRegistration'")
            .sign__info {{ $t('views.login.instructions') + ' ' + inputRegData}} 
            .sign__button
                buzz-button(:type="['wide']" @click="activeTab = 'login'") {{ $t('views.login.btn_back_to_login') }}

        .sign__data(v-else-if="activeTab === 'recovery step 1'")
            .sign__info {{ $t('views.login.instructions') }}
            .sign__button
                buzz-button(:type="['wide']" @click="activeTab = 'login'") {{ $t('views.login.btn_back_to_login') }}

        .sign__data(v-else-if="activeTab === 'recovery step 2'")
            .sign__info {{ $t('views.login.instructions_final') }}

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getLocale } from '@/plugins/i18n.js'

export default {
    data() {
        return {
            isAgree: false,
            wasSubmited: false,
            activeTab: 'login',
            inputRegData: '',
            inputRegDataErrors: '',
            inputRecoveryData: '',
            inputPassReqErrors: '',
            user_agreement_page: `https://buzzoola.com/${getLocale()}/terms-publisher`,
            inputLoginData: {
                email: '',
                password: '',
            },
        }
    },
    computed: {
        ...mapGetters('Publisher', [
            'authErrors',
            'registrationSuccess',
            'registrationErrors',
            'passwordRecoveryRequestSuccess',
            'passwordRecoveryErrors',
        ]),
        login_errors() {
            let str = ''
            for (const [key, value] of Object.entries(this.authErrors)) {
                str += `${key}: ${value}, `
            }
            return str
        },
    },
    methods: {
        ...mapActions('Publisher', [
            'login',
            'registration',
            'confirmPasswordRecovery',
            'passwordRecoveryRequest',
        ]),

        inputLoginEmail(email) {
            this.inputLoginData.email = email
        },
        inputLoginPassword(password) {
            this.inputLoginData.password = password
        },
        signUp() {
            this.wasSubmited = true
            this.inputRegDataErrors = ''

            if (this.isAgree) {
                this.registration({
                    email: this.inputRegData,
                })
            }
        },
        changeAgreement() {
            this.isAgree = !this.isAgree
        },
    },
    watch: {
        registrationSuccess: function (newVal) {
            if (newVal) {
                this.activeTab = 'successRegistration'
            }
        },
        registrationErrors: function (newVal) {
            const errors = JSON.parse(JSON.stringify(newVal))
            for (const [key, value] of Object.entries(errors.errors)) {
                if (key === 'email') {
                    this.inputRegDataErrors += `${value}\n`
                }
            }
        },
        passwordRecoveryRequestSuccess: function (newVal) {
            if (newVal) {
                this.activeTab = 'recovery step 1'
            }
        },
        passwordRecoveryErrors: function (newVal) {
            const errors = JSON.parse(JSON.stringify(newVal))
            for (const [key, value] of Object.entries(errors.errors)) {
                if (key === 'email') {
                    this.inputPassReqErrors += `${value}\n`
                }
            }
        },
    },
    mounted() {
        if (this.$route.name === 'PasswordRecovery') {
            this.confirmPasswordRecovery(this.$route.params.key)
            this.activeTab = 'recovery step 2'
        }
    },
}
</script>

<style lang="stylus">

.sign
    border-radius 5px
    display inline-block
    width 450px
    min-height 400px
    margin-bottom 30px
    background-color $white
    text-align left
    vertical-align middle
    +mobile()
        width 90vw
        max-width 450px
    &-wrap
        height 100vh
        display flex
        align-items center
        justify-content center
    &__input
        &-wrap
            display flex
            align-items flex-start
            margin-bottom 45px
        &-link
            text-decoration none
            display inline
            border-bottom 1px dotted $black
            color inherit
            ^[1]-wrap_err &
                border-bottom 1px dotted $red
        &-text
            display inline
            margin-right 5px
            &-wrap
                padding-left 5px
                color $black
                ^[1]-wrap_err &
                    color $red
    &__head
        box-sizing border-box
        position relative
        z-index 1
        width 100%
        padding 30px 70px 0
        text-align center
        +mobile()
            padding-left 10vw
            padding-right 10vw
    &__step
        display inline-block
        width auto
        margin-right 48px
        padding-bottom 25px
        border-bottom 2px solid transparent
        fontSize(20,20)
        color $blue
        cursor pointer
        &:hover
            color $red
        &:last-child
            margin-right 0
        +mobile()
            margin-right 40px
            fontSize(16,16)
        &_active
            border-bottom 2px solid $yellow
            color $deepBlack
            cursor auto
            &:hover
                color $deepBlack
        &_title
            margin 0
            color $deepBlack
            cursor auto
            &:hover
                color $deepBlack
    &__close
        position absolute
        top 30px
        right 30px
        display inline-block
        width 20px
        height 20px
        cursor pointer
    &__data
        box-sizing border-box
        position relative
        margin-top -2px
        padding 30px 70px 40px
        border-top 2px solid $silver
        fontSize(14,18)
        text-align left
        color $deepBlack
        +mobile()
            padding-left 10vw
            padding-right 10vw
    &__txt
        text-align center
    &__desc
        width 330px
        margin-left -10px
        margin-bottom 30px
        text-align center
        &:last-child
            margin-bottom 0
    &__info
        margin 30px auto
        text-align center
        fontSize(16, 22)
    &__button
        margin 15px 0 30px
    &__soc-item
        display inline-block
        width 50px
        margin-right 15px
        &:last-child
            margin-right 0
    &__link
        text-decoration none
        display inline-block
        margin-right 37px
        fontSize(14,16)
        &:last-child
            margin-right 0
    &__input-group
        margin-top 12px
</style>
